import React from "react";
import { NavLink } from "react-router-dom";
import Classes from "./style/footer.module.css";
export default function Footer() {
  return (
    <footer className={`${Classes.section_footer}  ${Classes.footer}`}>
      <div
        className={`${Classes.container} ${Classes.grid} ${Classes.grid_four_column}`}
      >
        <div className={`${Classes.f_about}`}>
          <h3>About</h3>
          <span>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione,
            sit itaque laboriosam aperiam quidem id aspernatur, sunt rem dolores
            molestias non unde sequi beatae quibusdam ducimus iste cum facere
            aut.
          </span>
        </div>
        <div className={`${Classes.f_links}`}>
          <h3>Links</h3>
          <ul>
            <li>
              <span className="material-symbols-outlined"> double_arrow </span>
              <NavLink to="/home">Home</NavLink>
            </li>
            <li>
              <span className="material-symbols-outlined"> double_arrow </span>
              <NavLink to="/about">About</NavLink>
            </li>
            <li>
              <span className="material-symbols-outlined"> double_arrow </span>
              <NavLink to="/service">Service</NavLink>
            </li>
            <li>
              <span className="material-symbols-outlined"> double_arrow </span>
              <NavLink to="/contact">Contact</NavLink>
            </li>
          </ul>
        </div>
        <div className={Classes.f_services}>
          <h3>Services</h3>
          <ul>
            <li>
              <span className="material-symbols-outlined"> double_arrow </span>
              <NavLink to="/service">Bed</NavLink>
            </li>
            <li>
              <span className="material-symbols-outlined"> double_arrow </span>
              <NavLink to="/service">Cheir</NavLink>
            </li>
            <li>
              <span className="material-symbols-outlined"> double_arrow </span>
              <NavLink to="/service">Cupboard</NavLink>
            </li>
            <li>
              <span className="material-symbols-outlined"> double_arrow </span>
              <NavLink to="/service">Locker</NavLink>
            </li>
            <li>
              <span className="material-symbols-outlined"> double_arrow </span>
              <NavLink to="/service">Mini Drawer</NavLink>
            </li>
            <li>
              <span className="material-symbols-outlined"> double_arrow </span>
              <NavLink to="/service">Showcase</NavLink>
            </li>
            <li>
              <span className="material-symbols-outlined"> double_arrow </span>
              <NavLink to="/service">Computer Table</NavLink>
            </li>
            <li>
              <span className="material-symbols-outlined"> double_arrow </span>
              <NavLink to="/service">Large Showcase</NavLink>
            </li>
            <li>
              <span className="material-symbols-outlined"> double_arrow </span>
              <NavLink to="/service">Table</NavLink>
            </li>
            <li>
              <span className="material-symbols-outlined"> double_arrow </span>
              <NavLink to="/service">Tea Table</NavLink>
            </li>
          </ul>
        </div>
        <div className={Classes.f_address}>
          <h3>Have a Question</h3>
          <address>
            <div>
              <code>
                <span className="material-symbols-outlined"> location_on </span>{" "}
                Howrah, india
              </code>
            </div>
            <div>
              <code>
                <span className="material-symbols-outlined"> call </span>
                <a href="tel:+91 9064749861">+91 9064749861</a>
              </code>
            </div>
            <div>
              <code>
                <span className="material-symbols-outlined"> mail </span>
                <a href="mailto:mahapravufurniture@gmail.com">
                  mahapravufurniture@gmail.com
                </a>
              </code>
            </div>
          </address>
        </div>
      </div>
      <div className={Classes.container}>
        <div className={Classes.f_social_icons}>
          <a
            href="https://www.facebook.com/abir.santra.330/"
            rel="noreferrer"
            target="_blank"
          >
            <i
              className={`fa-brands fa-square-facebook ${Classes.social_icone}`}
            ></i>
          </a>
          <a
            href="https://www.instagram.com/abir_santra_ig/"
            rel="noreferrer"
            target="_blank"
          >
            <i
              className={`fa-brands fa-square-instagram ${Classes.social_icone}`}
            ></i>
          </a>
          <a
            href="https://twitter.com/AbirSantra9"
            rel="noreferrer"
            target="_blank"
          >
            <i
              className={`fa-brands fa-square-twitter ${Classes.social_icone}`}
            ></i>
          </a>
          <a
            href="https://github.com/Jonty-Abir"
            rel="noreferrer"
            target="_blank"
          >
            <i
              className={`fa-brands fa-square-github ${Classes.social_icone}`}
            ></i>
          </a>
        </div>
        <div className={`${Classes.f_credits}`}>
          <span>Copyright © @mahapravufurniture </span>
        </div>
      </div>
      
    </footer>
  );
}
